import { createAsyncThunk, createSlice, isAnyOf } from "@reduxjs/toolkit";
import { API_ENDPOINTS, METHOD_TYPE } from "../../utils/apiUrls";
import api from "../../utils/api";

const initialState = {
    isLoading: false,
    error: null,
    currencyList : [],
    fxRatesList : {rows: [], count: 0, totalPages: 0, currentPage: 1, type: 200},
    fxRateDetail : {}, 
    fxRateHistoryList : [],
    paymentHistoryList: [],
    qrData : '',
    activePlanData: null,
}

export const generateGoogleAuthenticatorQR = createAsyncThunk("user/generateGoogleAuthenticatorQR", async (requestData) => {
    try {
        let data = {
            method: METHOD_TYPE.get,
            url: API_ENDPOINTS.generateGoogleAuthenticatorQR
        };
        const response = await api(data);
        return response.data;

    } catch (error) {
        throw error?.response?.data;
    }
});

export const manageGoogleAuthenticator = createAsyncThunk("user/manageGoogleAuthenticator", async (requestData) => {
    try {
        let data = {
            method: METHOD_TYPE.post,
            url: API_ENDPOINTS.manageGoogleAuthenticator,
            data : requestData
        };
        const response = await api(data);
        return response.data;

    } catch (error) {
        throw error?.response?.data;
    }
});

export const getPaymentHistory = createAsyncThunk("getPaymentHistory", async (queryParam) => {
    try {
        let data = {
            method: METHOD_TYPE.post,
            url: API_ENDPOINTS.getPaymentHistory + queryParam,
        };
        const response = await api(data);
        return response.data.data;

    } catch (error) {
        throw error?.response?.data;
    }
});

export const fetchActivePlanDetails = createAsyncThunk("myaccount/fetchActivePlanDetails", async () => {
    try {
        const data = {
            method: METHOD_TYPE.get,
            url: API_ENDPOINTS.fetchActivePlan,
        };
        const response = await api(data);
        return response.data?.data ?? response.data;

    } catch (error) {
        throw error?.response?.data;
    }
});

const MyAccountSlice = createSlice({
    name: "myaccount",
    initialState,
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            .addCase(generateGoogleAuthenticatorQR.fulfilled, (state, { payload }) => {
                state.isLoading = false;
                state.error = null;
                state.qrData = payload.data;
            })
            .addCase(manageGoogleAuthenticator.fulfilled, (state, { payload }) => {
                state.isLoading = false;
                state.error = null;
            })
            .addCase(getPaymentHistory.fulfilled, (state, action) => {
                state.isLoading = false;
                state.error = null;
                state.paymentHistoryList = action.payload
            })
            .addCase(fetchActivePlanDetails.fulfilled, (state, { payload }) => {
                state.isLoading = false;
                state.error = null;
                state.activePlanData = payload;
            })
            .addMatcher(isAnyOf(generateGoogleAuthenticatorQR.pending, manageGoogleAuthenticator.pending, getPaymentHistory.pending, fetchActivePlanDetails.pending), (state) => {
                state.isLoading = true;
            })
            .addMatcher(isAnyOf(generateGoogleAuthenticatorQR.rejected, manageGoogleAuthenticator.rejected, getPaymentHistory.rejected, fetchActivePlanDetails.rejected), (state, { error }) => {
                state.isLoading = false;
                state.error = (error) ? error.message : "Request Failed Please Try Again ";
            })
    }
});

const myAccountReducer = MyAccountSlice.reducer;
export default myAccountReducer;
